import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AdminLayout } from '../components/layout/AdminLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { RoleRoute } from './RoleRoute';
import { ModuleRoute } from './ModuleRoute';
import Login from '../pages/Login';
import SetPassword from '../pages/SetPassword';
import ForgotPassword from '../pages/ForgotPassword';
// Super Admin
import SADashboard from '../pages/super-admin/Dashboard';
import SAStatistics from '../pages/super-admin/Statistics';
import CommuneList from '../pages/super-admin/CommuneList';
import CommuneDetail from '../pages/super-admin/CommuneDetail';
import CommuneForm from '../pages/super-admin/CommuneForm';
import UserList from '../pages/super-admin/UserList';
import Coverage from '../pages/super-admin/Coverage';
import Discovery from '../pages/super-admin/Discovery';
import Broadcast from '../pages/super-admin/Broadcast';
import GroupModeration from '../pages/super-admin/GroupModeration';
// Commune Admin
import CADashboard from '../pages/commune-admin/Dashboard';
import ArticleList from '../pages/commune-admin/articles/ArticleList';
import ArticleForm from '../pages/commune-admin/articles/ArticleForm';
import CategoryListPage from '../pages/commune-admin/categories/CategoryList';
import ReportList from '../pages/commune-admin/reports/ReportList';
import ReportDetail from '../pages/commune-admin/reports/ReportDetail';
import ReportCategories from '../pages/commune-admin/reports/ReportCategories';
import RoadworkList from '../pages/commune-admin/travaux/RoadworkList';
import EventList from '../pages/commune-admin/events/EventList';
import EventForm from '../pages/commune-admin/events/EventForm';
import EventRegistrations from '../pages/commune-admin/events/EventRegistrations';
import AnnuaireList from '../pages/commune-admin/annuaire/AnnuaireList';
import AnnuaireForm from '../pages/commune-admin/annuaire/AnnuaireForm';
import Contributions from '../pages/commune-admin/contributions/Contributions';
// Espace pro (contributeurs : commerces / associations / lieux culturels)
import ProLayout from '../pages/pro/ProLayout';
import ProEntry from '../pages/pro/ProEntry';
import ProArticleList from '../pages/pro/ProArticleList';
import ProArticleForm from '../pages/pro/ProArticleForm';
import ProEventList from '../pages/pro/ProEventList';
import ProEventForm from '../pages/pro/ProEventForm';
import AgentList from '../pages/commune-admin/agents/AgentList';
import BlockedCitizenList from '../pages/commune-admin/citizen-blocks/BlockedCitizenList';
import ContributorList from '../pages/commune-admin/contributors/ContributorList';
import Settings from '../pages/commune-admin/settings/Settings';
import StatisticsPage from '../pages/commune-admin/statistics/StatisticsPage';
import AlertList from '../pages/commune-admin/alerts/AlertList';
import SchoolList from '../pages/commune-admin/schools/SchoolList';
import SchoolForm from '../pages/commune-admin/schools/SchoolForm';
import SchoolDetail from '../pages/commune-admin/schools/SchoolDetail';
import FormListPage from '../pages/commune-admin/forms/FormList';
import FormBuilder from '../pages/commune-admin/forms/FormBuilder';
import FormDetailPage from '../pages/commune-admin/forms/FormDetail';
import TicketListPage from '../pages/commune-admin/messaging/TicketList';
import TicketDetailPage from '../pages/commune-admin/messaging/TicketDetail';
import GroupListPage from '../pages/commune-admin/messaging/GroupList';
import GroupDetailPage from '../pages/commune-admin/messaging/GroupDetail';
import PollListPage from '../pages/commune-admin/polls/PollList';
import ProjectListPage from '../pages/commune-admin/projects/ProjectList';
import NotificationSend from '../pages/commune-admin/notifications/NotificationSend';
import PharmacyDutyCalendar from '../pages/commune-admin/health/PharmacyDutyCalendar';
import LegalActList from '../pages/commune-admin/legal-acts/LegalActList';
import LegalActForm from '../pages/commune-admin/legal-acts/LegalActForm';
import LegalActAudit from '../pages/commune-admin/legal-acts/LegalActAudit';
import CouncilSessionList from '../pages/commune-admin/council-sessions/CouncilSessionList';
import TileList from '../pages/commune-admin/tiles/TileList';
import TileForm from '../pages/commune-admin/tiles/TileForm';
import DatasetList from '../pages/commune-admin/datasets/DatasetList';
import DatasetNew from '../pages/commune-admin/datasets/DatasetNew';
import DatasetDetail from '../pages/commune-admin/datasets/DatasetDetail';
export const router = createBrowserRouter([
    { path: '/login', element: _jsx(Login, {}) },
    { path: '/set-password', element: _jsx(SetPassword, {}) },
    { path: '/forgot-password', element: _jsx(ForgotPassword, {}) },
    {
        element: _jsx(ProtectedRoute, {}),
        children: [
            {
                element: _jsx(AdminLayout, {}),
                children: [
                    // Super Admin routes
                    {
                        path: '/super-admin',
                        element: _jsx(RoleRoute, { allowedRoles: ['ROLE_SUPER_ADMIN'] }),
                        children: [
                            { index: true, element: _jsx(SADashboard, {}) },
                            { path: 'communes', element: _jsx(CommuneList, {}) },
                            { path: 'communes/new', element: _jsx(CommuneForm, {}) },
                            { path: 'communes/:id', element: _jsx(CommuneDetail, {}) },
                            { path: 'communes/:id/edit', element: _jsx(CommuneForm, {}) },
                            { path: 'users', element: _jsx(UserList, {}) },
                            { path: 'coverage', element: _jsx(Coverage, {}) },
                            { path: 'statistics', element: _jsx(SAStatistics, {}) },
                            { path: 'discovery', element: _jsx(Discovery, {}) },
                            { path: 'broadcast', element: _jsx(Broadcast, {}) },
                            { path: 'group-reports', element: _jsx(GroupModeration, {}) },
                        ],
                    },
                    // Commune Admin routes (operators included, restricted to their modules)
                    {
                        path: '/commune',
                        element: _jsx(RoleRoute, { allowedRoles: ['ROLE_ADMIN_COMMUNE', 'ROLE_OPERATOR', 'ROLE_SUPER_ADMIN'] }),
                        children: [
                            { index: true, element: _jsx(CADashboard, {}) },
                            { path: 'notifications', element: _jsx(NotificationSend, {}) },
                            { path: 'habitants-bloques', element: _jsx(BlockedCitizenList, {}) },
                            { path: 'tiles', element: _jsx(TileList, {}) },
                            { path: 'tiles/new', element: _jsx(TileForm, {}) },
                            { path: 'tiles/:id/edit', element: _jsx(TileForm, {}) },
                            {
                                element: _jsx(ModuleRoute, { modules: ['actualites'] }),
                                children: [
                                    { path: 'articles', element: _jsx(ArticleList, {}) },
                                    { path: 'articles/new', element: _jsx(ArticleForm, {}) },
                                    { path: 'articles/:id/edit', element: _jsx(ArticleForm, {}) },
                                    { path: 'categories', element: _jsx(CategoryListPage, {}) },
                                ],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['actualites', 'agenda'] }),
                                children: [{ path: 'contributions', element: _jsx(Contributions, {}) }],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['agenda'] }),
                                children: [
                                    { path: 'events', element: _jsx(EventList, {}) },
                                    { path: 'events/new', element: _jsx(EventForm, {}) },
                                    { path: 'events/:id/edit', element: _jsx(EventForm, {}) },
                                    { path: 'events/:id/registrations', element: _jsx(EventRegistrations, {}) },
                                ],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['annuaire'] }),
                                children: [
                                    { path: 'annuaire', element: _jsx(AnnuaireList, {}) },
                                    { path: 'annuaire/new', element: _jsx(AnnuaireForm, {}) },
                                    { path: 'annuaire/:id/edit', element: _jsx(AnnuaireForm, {}) },
                                ],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['signalement'] }),
                                children: [
                                    { path: 'reports', element: _jsx(ReportList, {}) },
                                    { path: 'reports/:id', element: _jsx(ReportDetail, {}) },
                                ],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['travaux'] }),
                                children: [{ path: 'travaux', element: _jsx(RoadworkList, {}) }],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['alertes'] }),
                                children: [{ path: 'alerts', element: _jsx(AlertList, {}) }],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['vie_scolaire'] }),
                                children: [
                                    { path: 'schools', element: _jsx(SchoolList, {}) },
                                    { path: 'schools/:uai', element: _jsx(SchoolDetail, {}) },
                                    { path: 'schools/:uai/edit', element: _jsx(SchoolForm, {}) },
                                ],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['demarches'] }),
                                children: [
                                    { path: 'forms', element: _jsx(FormListPage, {}) },
                                    { path: 'forms/new', element: _jsx(FormBuilder, {}) },
                                    { path: 'forms/:id', element: _jsx(FormDetailPage, {}) },
                                    { path: 'forms/:id/edit', element: _jsx(FormBuilder, {}) },
                                ],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['messagerie'] }),
                                children: [
                                    { path: 'tickets', element: _jsx(TicketListPage, {}) },
                                    { path: 'tickets/:id', element: _jsx(TicketDetailPage, {}) },
                                    { path: 'groups', element: _jsx(GroupListPage, {}) },
                                    { path: 'groups/:id', element: _jsx(GroupDetailPage, {}) },
                                ],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['sondages'] }),
                                children: [{ path: 'polls', element: _jsx(PollListPage, {}) }],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['projets_citoyens'] }),
                                children: [{ path: 'projects', element: _jsx(ProjectListPage, {}) }],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['urgences_sante'] }),
                                children: [{ path: 'pharmacy-duties', element: _jsx(PharmacyDutyCalendar, {}) }],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['affichage_legal'] }),
                                children: [
                                    { path: 'legal-acts', element: _jsx(LegalActList, {}) },
                                    { path: 'legal-acts/new', element: _jsx(LegalActForm, {}) },
                                    { path: 'legal-acts/audit', element: _jsx(LegalActAudit, {}) },
                                    { path: 'legal-acts/:id/edit', element: _jsx(LegalActForm, {}) },
                                    { path: 'legal-acts/:id/audit', element: _jsx(LegalActAudit, {}) },
                                    { path: 'council-sessions', element: _jsx(CouncilSessionList, {}) },
                                ],
                            },
                            {
                                element: _jsx(ModuleRoute, { modules: ['donnees'] }),
                                children: [
                                    { path: 'donnees', element: _jsx(DatasetList, {}) },
                                    { path: 'donnees/new', element: _jsx(DatasetNew, {}) },
                                    { path: 'donnees/:id', element: _jsx(DatasetDetail, {}) },
                                ],
                            },
                            // Admin-only screens (the API refuses operators there too).
                            {
                                element: _jsx(RoleRoute, { allowedRoles: ['ROLE_ADMIN_COMMUNE', 'ROLE_SUPER_ADMIN'] }),
                                children: [
                                    { path: 'reports/categories', element: _jsx(ReportCategories, {}) },
                                    { path: 'agents', element: _jsx(AgentList, {}) },
                                    { path: 'contributors', element: _jsx(ContributorList, {}) },
                                    { path: 'settings', element: _jsx(Settings, {}) },
                                    { path: 'statistics', element: _jsx(StatisticsPage, {}) },
                                ],
                            },
                        ],
                    },
                    // Pro space (contributor accounts managing 0..n directory entries)
                    {
                        path: '/pro',
                        element: _jsx(RoleRoute, { allowedRoles: ['ROLE_PRO'] }),
                        children: [
                            {
                                element: _jsx(ProLayout, {}),
                                children: [
                                    { index: true, element: _jsx(ProEntry, {}) },
                                    { path: 'articles', element: _jsx(ProArticleList, {}) },
                                    { path: 'articles/new', element: _jsx(ProArticleForm, {}) },
                                    { path: 'articles/:id/edit', element: _jsx(ProArticleForm, {}) },
                                    { path: 'events', element: _jsx(ProEventList, {}) },
                                    { path: 'events/new', element: _jsx(ProEventForm, {}) },
                                    { path: 'events/:id/edit', element: _jsx(ProEventForm, {}) },
                                ],
                            },
                        ],
                    },
                    // Default redirect
                    { path: '/', element: _jsx(Navigate, { to: "/login", replace: true }) },
                ],
            },
        ],
    },
]);
